import { createSelector } from "reselect";

//Configuration
import { visitSequenceConfiguration } from "src/constants/filters_configurations/compliance";

export const visitSequenceFilterConfigSelector = createSelector(
  () => visitSequenceConfiguration
);
